<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-card>
      <v-card-title> Dettaglio Conteggio </v-card-title>
      <template v-if="!loading_conteggio">
        <v-card-subtitle class="mt-0">
          <template v-if="ordine != null && !loading_conteggio">
            Ordine # {{ ordine.numero }}
            <br />
          </template>
          Cliente: <b>{{ cliente.nome }}</b>
          <br />
          Stato:
          <span
            :class="
              conteggio.id_contabile
                ? 'purple--text'
                : conteggio.confermato
                ? 'green--text'
                : 'amber--text'
            "
            >{{
              conteggio.id_contabile
                ? "Contabilizzato"
                : conteggio.confermato
                ? "Confermato"
                : "In Corso"
            }}</span
          >
          <br />
          Tipo:
          <span :class="conteggio.tipo == 1 ? 'blue--text' : 'purple--text'"
            >{{ conteggio.tipo == 1 ? "Carrello" : "Lista" }}
          </span>
          <br />
          Contato da: {{ creatore }}
        </v-card-subtitle>

        <v-card-text>
          <template v-if="conteggio.tipo == 1">
            <v-row>
              <v-col>
                <v-btn outlined color="blue" class="" @click="view = 0"
                  ><v-icon class="mr-2">mdi-clipboard</v-icon> Lista</v-btn
                >
                <v-btn outlined color="purple" class="ml-4" @click="view = 1"
                  ><v-icon class="mr-2">mdi-cart</v-icon> Carrelli</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mt-4" />
          </template>
          <template v-if="view == 0">
            <template v-for="prodotto in lista_combinata">
              <ContDettEl
                :key="prodotto.id"
                :prodotto="prodotto"
                :listino="listino"
              />
              <!-- <v-divider :key="prodotto.id + '-div'" /> -->
            </template>
          </template>
          <template v-else-if="view == 1">
            <v-tabs show-arrows="">
              <v-tab
                v-for="carrello in conteggio.carrelli"
                :key="carrello.id_carrello"
                @click="
                  put_product({
                    carrello: carrello,
                    id_carrello: carrello.id_carrello,
                  })
                "
                :class="
                  selected_cart.id == carrello.id_carrello
                    ? 'grey lighten-4'
                    : ''
                "
              >
                C # {{ carrello.numero }}
              </v-tab>
            </v-tabs>
            <v-row
              v-if="selected_cart.prodotti.length == 0"
              class="mt-6"
              no-gutters
            >
              <v-col cols="12" class="text-center grey--text">
                Nessun prodotto contato in questo carrello
              </v-col>
            </v-row>
            <v-list v-else>
              <ProdottoCarrelloElement
                v-for="prodotto in selected_cart.prodotti"
                :prodotto="prodotto"
                :listino="listino"
                :key="prodotto.id"
              />
            </v-list>
            <v-divider class="mt-4" />
          </template>
          <v-row class="mt-6" no-gutters>
            <v-col cols="12" v-if="ordine">
              Totale Ordine: € {{ totale_ordinato.toFixed(2) }}
            </v-col>
            <v-col cols="12">
              Totale Contato: {{ totale_contato.toFixed(2) }} € + IVA ({{
                tot_iva_contato.toFixed(2)
              }}
              €)
            </v-col>
            <v-col cols="12" v-if="ordine">
              Discrepanza:
              <v-icon size="15" :color="totale_discrepanza.color">
                {{ totale_discrepanza.icon }}
              </v-icon>
              € {{ totale_discrepanza.tot.toFixed(2) }}
            </v-col>
            <v-col cols="12" v-if="ordine">
              Totale Trasporto: € {{ tot_trasporto.toFixed(2) }} € + IVA ({{
                tot_iva_trasporto.toFixed(2)
              }}
              €)
            </v-col>
            <v-col cols="12" class="font-weight-bold">
              Totale Documento:
              {{ (totale_contato + tot_trasporto).toFixed(2) }} € + IVA ({{
                (tot_iva_contato + tot_iva_trasporto).toFixed(2)
              }}
              €)</v-col
            >
          </v-row>
        </v-card-text>
      </template>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="close()">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ContDettEl from "./conteggio_dettaglio_element_mobile.vue";
import conteggio_dettaglio_mixin from "../../mixin/conteggio_dettaglio_mixin";
import ProdottoCarrelloElement from "../../desktop/dettaglio_conteggio/conteggio_prodotto_carrello_element.vue";
export default {
  components: {
    ContDettEl,
    ProdottoCarrelloElement,
  },
  mixins: [conteggio_dettaglio_mixin],
  watch: {
    $route(to, from) {
      if (from.hash === "#dettaglio-conto" && this.dialog == true) {
        this.dialog = false;
      }
    },
  },
  methods: {
    // open() {
    //   this.dialog = true;
    //   this.$router.push("#dettaglio-conto");
    // },
    close() {
      this.dialog = false;
      this.$router.back();
    },
  },
};
</script>